import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { getQaSelector } from '../../../utils/common'
import { Avatar, AVATAR_HEIGHT_24 } from '../../Avatar'
import { FloatingTooltip } from '../../Floating'
import { Link } from '../../Link'
import Text from '../../Text'
import { QA_NAME_DASHBOARD_BIRDVIEW_HOME_LINK } from '../DashboardBirdview.constants.qa'

import {
  checkIsBirdviewHomeContact,
  getBirdviewHomeContactTooltipKey,
} from './BirdviewHomeRow.utils'
import { BirdviewHomeRowCopyButton } from './BirdviewHomeRowCopyButton'

import * as styles from './BirdviewHomeRow.module.css'

function BirdviewHomeRow({ item }) {
  const { t } = useTranslation()

  return (
    <div className={styles.row}>
      <Avatar
        Icon={item.Icon}
        className={styles.icon}
        size={AVATAR_HEIGHT_24}
      />
      <div className={styles.body}>
        <Text isSecondary>{t(item.labelKey)}</Text>
        {checkIsBirdviewHomeContact(item) ? (
          <span className={styles.contact}>
            <FloatingTooltip
              content={t(getBirdviewHomeContactTooltipKey(item))}
              placement={FLOATING_ELEMENT_PLACEMENT.top}
            >
              <Link
                {...getQaSelector({
                  value: QA_NAME_DASHBOARD_BIRDVIEW_HOME_LINK,
                })}
                className={styles.link}
                to={item.href}
              >
                {item.value}
              </Link>
            </FloatingTooltip>
            <BirdviewHomeRowCopyButton value={item.value} />
          </span>
        ) : (
          <Text className={styles.value}>{item.value}</Text>
        )}
      </div>
    </div>
  )
}

export default BirdviewHomeRow
